// Authentication utility functions

// Determine backend URL based on current protocol and port
export const getBackendUrl = () => {
  // Use relative URL so nginx can proxy to the backend
  return '/api';
};

// Check if user is authenticated and token is not expired
export const isAuthenticated = () => {
  const token = localStorage.getItem('authToken');
  const expiration = localStorage.getItem('authExpiration');
  
  if (!token || !expiration) {
    return false;
  }
  
  const now = Date.now();
  const expirationTime = parseInt(expiration);
  
  if (now >= expirationTime) {
    // Token expired, clear storage
    clearAuth();
    return false;
  }
  
  return true;
};

// Get stored authentication token
export const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

// Get stored user info
export const getAuthUser = () => {
  return localStorage.getItem('authUser');
};

// Clear authentication data
export const clearAuth = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('authExpiration');
  localStorage.removeItem('authUser');
};

// Create authenticated fetch function
export const authenticatedFetch = async (url, options = {}) => {
  if (!isAuthenticated()) {
    throw new Error('Not authenticated');
  }
  
  const token = getAuthToken();
  
  // Add authorization header
  const authHeaders = {
    'Authorization': `Bearer ${token}`,
    ...options.headers
  };
  
  const response = await fetch(url, {
    ...options,
    headers: authHeaders
  });
  
  // Check for 401 unauthorized response
  if (response.status === 401) {
    // Token might be invalid, clear auth and throw error
    clearAuth();
    throw new Error('Authentication failed');
  }
  
  return response;
};

// Get time until token expires (in seconds)
export const getTimeUntilExpiration = () => {
  const expiration = localStorage.getItem('authExpiration');
  if (!expiration) return 0;
  
  const now = Date.now();
  const expirationTime = parseInt(expiration);
  
  return Math.max(0, Math.floor((expirationTime - now) / 1000));
}; 